import { FieldState } from "formstate";
import { IconButton, TextField } from "material-ui";
import { ActionDelete } from "material-ui/svg-icons";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

interface Props {
  vismaId: FieldState<number>;
  vismaCustomerNumber: FieldState<number>;
  onDelete: () => void;
  showButton: boolean;
  label?: string;
}

const Card = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px 12px 12px 16px;
  margin-top: 12px;
  background: #fafafa;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -8px;
`;

const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #555;
`;

const InputRow = styled.div`
  display: flex;
  gap: 16px;
`;

const Input = styled(TextField)`
  flex: 1 0 auto;
`;

@observer
class VismaInput extends React.Component<Props> {
  render() {
    const {
      vismaId,
      vismaCustomerNumber,
      onDelete,
      showButton: allowDelete,
      label,
    } = this.props;
    return (
      <Card>
        <CardHeader>
          {label ? <Label>{label}</Label> : <span />}
          {allowDelete && (
            <IconButton
              onClick={onDelete}
              style={{ padding: 4, width: 32, height: 32 }}
            >
              <ActionDelete color="#999" />
            </IconButton>
          )}
        </CardHeader>
        <InputRow>
          <Input
            type="number"
            value={vismaId.value}
            errorText={vismaId.error}
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              vismaId.onChange(parseInt(e.currentTarget.value, 10))
            }
            floatingLabelText="Användar-ID i Visma"
          />
          <Input
            type="number"
            value={vismaCustomerNumber.value}
            errorText={vismaCustomerNumber.error}
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              vismaCustomerNumber.onChange(parseInt(e.currentTarget.value, 10))
            }
            floatingLabelText="Kundnummer i Visma"
          />
        </InputRow>
      </Card>
    );
  }
}
export default VismaInput;
